export default __webpack_public_path__ + "static/media/tpad_smoke.ac6c3639.png";